import React from 'react';
import { IconSvgProps } from '@models/common';

const AlarmClock: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M4.167 2.5 1.667 5m16.667 0-2.5-2.5M5 15.833 3.334 17.5M15 15.833l1.667 1.667M10 7.5v3.333l1.667 1.667M10 17.5a6.667 6.667 0 1 0 0-13.334A6.667 6.667 0 0 0 10 17.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AlarmClock;
